﻿/**
 * Converts the given options set to a Map object using the option value as key
 * @param {Array<{value: string, label: string}>} options Options object.
 * @returns {Map.<string, {value: string, label: string}>} Map generated based on given options
 */
const optionsToValueMap = options => options.reduce((map, option) => {
    map.set(option.value, option);
    return map;
}, new Map());

export default optionsToValueMap;